// extracted by css-extract-rspack-plugin
export default {"checkbox":"checkbox-gGB7t6"};